import Immutable from 'immutable';

/*
 * Summarises data into a format suitable for consumption by the data visualization
 * components in the questionSetReview domain.
 * @param {orderedMap} classStudentProfiles - list student profiles
 * @param {list} responses - list of exam responses
 * @param {object} solution - exam solution
 */
export const getProfileQuestionResponseSummary = (
  classStudentProfiles,
  responses,
  solution,
  question
) => {
  const checklistItems = solution
    .get('solution')
    .get('exemplar_response_checklist_items');

  const imageUrl = question ? question.get('image_url') : null;

  return classStudentProfiles.map((profile) => {
    const response = responses.find(
      (resp) => resp.get('responder') === profile.get('profile_id')
    );

    const checklistReflections = response
      ? response.get('checklist_reflections', Immutable.List())
      : Immutable.List();

    return Immutable.Map({
      userId: profile.get('user_id'),
      userProfileId: profile.get('profile_id'),
      userFirstName: profile.get('first_name'),
      userLastName: profile.get('last_name'),
      imageUrl: response && imageUrl,
      response: response ? response : null,
      answer: response
        ? response.get('your_answer') || response.get('text_submitted_text')
        : null,
      grokked: response ? response.get('grokked') : null,
      correct: response && response.get('is_correct'),

      checklistReflections: checklistItems.map((item) => {
        const reflection = checklistReflections.find(
          (reflection) =>
            reflection.get('exemplar_response_checklist_item') ===
            item.get('id')
        );
        return Immutable.Map({
          userProfileId: profile.get('profile_id'),
          checklistItemId: item.get('id'),
          checklistItemDescription: item.get('description'),
          checked: reflection ? reflection.get('checked') : null,
        });
      }),
    });
  });
};
